const EUR_REGIONS = ["AT", "BE", "CY", "EE", "FI", "FR", "DE", "GR", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PT", "SK", "SI", "ES"];

const regionToCurrency = (region) => {
  if (region === "NZ") return "NZD";
  if (region === "AU") return "AUD";
  if (region === "US") return "USD";
  if (region === "GB" || region === "UK") return "GBP";
  if (EUR_REGIONS.includes(region)) return "EUR";
  return null;
};

const fromLocale = () => {
  try {
    const region = ((navigator.language || "").split("-")[1] || "").toUpperCase();
    return regionToCurrency(region);
  } catch {
    return null;
  }
};

const fromIp = async () => {
  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 2500);
    const res = await fetch("https://ipapi.co/json/", { signal: controller.signal });
    clearTimeout(timeout);
    if (!res.ok) return null;
    const data = await res.json();
    return regionToCurrency((data.country_code || "").toUpperCase());
  } catch {
    return null;
  }
};

// IP geolocation first, browser locale as fallback, NZD default
export const detectCurrency = async () => {
  const ip = await fromIp();
  if (ip) return ip;
  return fromLocale() || "NZD";
};
